<template>
  <div class="cxfy_2_001">
    <div class="search-box">
        <div class="left">
            <div class="top-content base-content" >
                <div class="item">
                    <div class="label" >房屋地址:</div>
                    <div class="value">
                        <Input clearable  v-model="params.fwdz" placeholder="请输入..." style="width: 300px"  />
                    </div>
                </div>
                <div class="item">
                    <div class="label" >维修状态:</div>
                    <div class="value"> 
                        <Select v-model="params.wxzt" placeholder="请选择..." clearable>
                        <Option v-for="item in ['待处理','已响应','已完成','取消预约']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
                <div class="item">
                    <div class="label" >维修人:</div>
                    <div class="value">
                        <Input clearable v-model="params.wxr" placeholder="请输入..." style="width: 300px" />
                    </div>
                </div> 
            </div>
            <div class="top-content base-content" >
                <div class="item">
                    <div class="label" >报修人:</div>
                    <div class="value">
                        <Input clearable v-model="params.bxr" placeholder="请输入..." style="width: 300px" />
                    </div>
                </div> 
                <div class="item">
                    <div class="label" >故障类型:</div>
                    <div class="value"> 
                        <Select clearable v-model="params.gzlx" placeholder="请选择...">
                        <Option v-for="item in ['水管管件','灯具电路','开锁换锁','家电清洗','门窗维修','墙/地面维修','安装拆除','家电维修','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
                <div class="item">
                    <div class="label" >故障区域:</div>
                    <div class="value"> 
                        <Select clearable v-model="params.gzqy" placeholder="请选择...">
                        <Option v-for="item in ['卧室','厨房','阳台','卫生间','客厅','其他']" :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </div>
                </div>
            </div>

        </div>
        <div class="right"> 
            <Button type="defaultdefault"   icon="ios-close-circle-outline"    @click="clear" class="btn">清空</Button>
            <Button type="primary"   icon="ios-search"    @click="init" class="btn">查询</Button> 
        </div> 
    </div> 
    <div class="operate-box"> 
        <Button type="success"   icon="ios-add-circle-outline"    @click="add" class="btn">新增</Button> 
<!--         
        <Button type="warning" ghost   icon="md-code-download"    @click="add" class="btn">导出</Button>  
      -->
     
    </div>
   
    <div class="data-box">
         <Table border :columns="columns" :data="dataList" class="table-class" :width="screenWidth*0.85" :height="screenHeight*0.7">
            <template #action="{ row, index } " >
                <div class="buttomGroup">
                    <!-- <div class="btn ck" @click="watchDetail(row)">查看</div> -->
                    <div class="btn tj" @click="watchDetail(row)">查看</div>
                
                    <div class="btn th" @click="operateResponse(row)">响应</div>
                    <div class="btn-big tg" @click="writeRepairCondition(row)" >填写维修情况</div> 
                    <div class="btn sc" @click="deleteRecord(row)" >删除</div> 
                    <!-- <div class="btn tg dc" @click="exportData(row.id)">导出</div> -->
                </div>
            </template>
         </Table>
        <div class="page-line">
            <Page :total="pageSetting.total" :page-size="pageSetting.pageSize" @on-page-size-change="pageSizeChange"
            @on-change="pageChange" show-elevator show-sizer show-total></Page>
        </div>
      
    </div>
    <detail-modal ref="detail" :data-detail="dataDetail" :key-list="keyList" :photo-key-list="photoKeyList" :other-key-list="otherKeyList"></detail-modal>
    <response-modal ref="response" :data-detail="dataDetail"></response-modal>
    <repair-modal ref="repair" :data-detail="dataDetail" :lld-table-data="lldList" :gsd-table-data="gsdList"></repair-modal>
    <add-repair-modal ref="addRepair" :data-detail="dataDetail"  @init="init"></add-repair-modal>
    <!-- 
    <update-house-modal ref="updateHouse" :house="dataDetail" @init="init"></update-house-modal>
    <other-operate-modal ref="otherOperate" :house-detail="dataDetail" @init="init"></other-operate-modal> -->
  </div>
</template>

<script> 
    import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx.js";
    import detailModal from '@/views/bggl/components/9小程序管理/components/base_detail_modal.vue'
    import addRepairModal from './components/add_repair_modal/add_repair_modal.vue'
    import updateHouseModal from '../../base_detail_modal/update_house_modal/update_house_modal.vue'
     import otherOperateModal from '../../base_detail_modal/other_operate_modal/other_operate_modal.vue'
     import responseModal from "./components/response_modal/response_modal.vue"
      import repairModal from "./components/repair_modal/repair_modal.vue"
export default {
  name:"topUser",
  components:{detailModal, addRepairModal,updateHouseModal,otherOperateModal,responseModal,repairModal},
  created(){
        // this.initializeData()
        // console.log("screenWidth==",screenWidth)
        this.init()
    },
    computed: {
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    data() {
        return {
     
            params:{
                fwdz:"",//房屋地址
                wxzt:"",//维修状态
                bxr:"",//报修人
                wxr:"",//维修人 
                gzlx:"",//故障类型
                gzqy:"",//故障区域
            },

            columns:[
                // {title: '序号', type: 'index', width: 60, align: 'center'},
                {title: '房屋地址', key: 'houseAddress', width: 300, align: 'center',fixed:"left"},
               
                {title: '维修状态', key: 'repairStatus', width: 200, align: 'center'},
               
                {title: '报修人', key: 'repairPerson', width: 200, align: 'center'},
                {title: '报修人联系电话', key: 'repairPersonContact', width: 200, align: 'center'},
                {title: '报修时间', key: 'repairTime', width: 200, align: 'center'},
                {title: '房屋情况描述', key: 'houseDescription', width: 200, align: 'center'},
                {title: '维修人', key: 'repairer', width: 200, align: 'center'},
                {title: '维修工时', key: 'repairHours', width: 200, align: 'center'},
                {title: '故障类型', key: '故障类型', width: 200, align: 'center'},
                {title: '故障区域', key: '故障区域', width: 200, align: 'center'},
                {title: '响应时间', key: 'responseTime', width: 200, align: 'center'},
                {title: '响应备注', key: 'responseNote', width: 200, align: 'center'},
                
                {title: '操作', slot: 'action', width: 340, align: 'center',fixed:"right"},

            ],
            keyList:[
                "故障区域","故障类型",
                "房屋情况描述", "报修人账号", "租客留言", "维修工时", "开始维修时间","结束维修时间",
                "维修状态",  "报修人", "维修人电话", "所在小区","收款金额", 
                "报修人联系电话", "预约上门时间", "响应时间", "维修人", "租客账号",
                "响应备注",
                ],
            photoKeyList:[ "客厅照片","卧室照片", "厨房照片", "卫生间照片",],
            otherKeyList:[
                "其他卡", "套内建筑面积", "出租部位", "是否更换收房人", "委托人电话",
                "街道办", "备注2", "楼号", "建成年代", "是否开通燃气",
                "指导月租金", "出租间套数", "业务序号",  "出租方式",
                "是否可同步", "钥匙/密码", "权属证明编号", "院门牌号", "首页推荐",
                "封面照片", "接收状态", "其他照片", "备注",
                "装修标准", "出租用途", "特别约定", "授权委托书", 
                "房源标签", "中止日期", "装修后照片", "业务员编号", "房屋原貌",
                "坐落", "房源分类", "房源简介", "装修图片", "装修视频",
                "离职分配", "室号", "房源类型", "说明", "权属证明名称",
                "地铁线", "受托代理人姓名", "路街巷", "合同中止时间", "临街状态",
                "产权人身份证号", "交房日期", "产权性质", "公示坐落", "不动产单元号",
                "房源标题", "中止原因"
            ],
            //单独拿出来
            //房屋托管合同信息  产证信息 身份证信息

            pageSetting:{
                pageSize: 15,
                pageIndex: 1,
                total: 0
            },
            dataList:[

            ],
            dataDetail:{
                "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息

                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
            },//单个房源详情
            lldList:[],// 
            gsdList:[],// 
           
        }
    },
    
    mounted(){},
    watch:{},
    methods:{
        init(){
            console.log("父级666")
            console.log("params===",this.params)
            let params=this.params
            params.pageSize=this.pageSetting.pageSize
            params.pageIndex=this.pageSetting.pageIndex
            smwxMethod_9_001.selectList(params).then((res)=>{
                console.log("res===",res)
            
                this.$nextTick(()=>{
                    this.dataList=res.data.list
                    this.pageSetting.total=res.data.total 
                    // this.watchDetail({id:"60a23c03e4b0bcb167f69b2e:60f685a3e4b0ce8c613253fc"})
                })
                

            })
        },
        // 响应维修
        operateResponse(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data.smwxInfo 
                console.log("this.dataDetail==",this.dataDetail)
                this.$refs.response.responseModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            }) 
        },
        // 查看详情
        watchDetail(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data.smwxInfo 
                this.$refs.detail.detailModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            })
        },
        // 填写维修情况
        writeRepairCondition(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data.smwxInfo 
             
                this.lldList=res.data.lldList 
                this.gsdList=res.data.gsdList 
               
         
                this.$refs.repair.updateModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            })
        },
          // 修改非附件信息
          updateInfo(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getByIdforUpdate(params).then((res)=>{
            
                this.dataDetail=res.data 
                // console.log("dataDetail===",this.)
                this.$refs.updateHouse.updateModal=true
               
            })
        },
        // 逻辑删除
        deleteRecord(row){
            let _this=this
            this.$Modal.confirm({
              title: '确认删除提醒',
              content: `<br>请注意，点击确认后不可撤回<br>`,
              onOk(){
                let param={id:row.id}
               
                smwxMethod_9_001.deleteRecord(param).then((res)=>{
                  console.log("删除——res====",res)
                  if(res.data.deleteRes!=0 && res.data.deleteRes!=null){
                    _this.$Message.success("删除成功！")
                    _this.init()
                    _this.updateModal=false
               
                  }
                })


              }})
       
        },
        // 其他业务
        otherOperate(row){
            let params={
                id:row.id
            }
            smwxMethod_9_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.dataDetail=res.data 
                this.$nextTick(()=>{
                    this.$refs.otherOperate.otherModal=true
                    this.$refs.otherOperate.changeIllustrate("修改附件")
                })

            })
         
        },
        // 新增
        add(){
            this.dataDetail={
                "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息

                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
            }
            this.$refs.addRepair.add_repair_modal=true
        },
        clear(){
            this.params={
                fwdz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"",//业务状态
                htqzsj:null,//合同起止时间
                htStart:"",htEnd:"",//拆分为start和end时间
                pageSize:15,
                pageIndex:1,
            }
            this.init()
        },
        pageSizeChange(i) {
            this.pageSetting.pageSize = i;
            this.init()
        },
        pageChange(i) {
            this.pageSetting.pageIndex = i;
            this.init()
        },
        changeDate(date){
            // console.log("date==",date)
            this.params.htStart=date[0]
            this.params.htEnd=date[1]
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            console.log("date==",date)

            // 获取年月日时分秒
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            // 拼接成 "YYYY-MM-DD HH:mm:ss" 格式
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
    }


}
</script>

  
  <style lang="scss" >
@import '9_001_smwx.scss'; 

  </style>